
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorDeInicio } from './controlador';
    import Jquery from 'jquery';
    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorDeInicio;
         
        public get Bultos() { return this.Controlador.Bultos; }
        public get Estado() { return this.Controlador.Vista.Estado; }

        public Eliminar( item: string )
        {
            let ee = this.Bultos.findIndex( x => x.Id == item );
            if ( ee > -1 )
            {
                this.Bultos.splice( ee, 1 );
            }

            Jquery( '#input-bulto' ).focus();

        }
        
    }
